import React, { useState } from "react";
import FincludeLogo from "../../../assets/images/finclude.png";
import { Field, Form } from "react-final-form";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import ValidatedInput from "../../common/ValidatedInput";

const LoginForm = ({ onSubmit }) => {
  const [passwordType, setPasswordType] = useState("password");
  const [passwordClass, setPasswordClass] = useState("");

  const handlePasswordVisibility = () => {
    if (passwordType === "text") {
      setPasswordType("password");
      setPasswordClass("");
    } else {
      setPasswordType("text");
      setPasswordClass("password-show");
    }
  };

  return (
    <Form
      onSubmit={onSubmit}
      render={({
        submitError,
        handleSubmit,
        form,
        submitting,
        pristine,
        values,
      }) => (
        <form className="box mw-400 p-sm-5" onSubmit={handleSubmit}>
          <img
            className="d-block mx-auto mb-4"
            src={FincludeLogo}
            alt="Finclude"
          />
          {submitError && (
            <p className="text-center text-error">{submitError} </p>
          )}
          <div className="fin-col mb-2">
            <Field
              className="fin-control mb-2"
              type="text"
              name="email"
              parse={(value) => value.trim()}
              component="input"
              placeholder="Email"
            />
            <div className={`password-wrapper ${passwordClass}`}>
              <a className="password-type-toggle">
                <i
                  className={"icon-eye icon-md"}
                  onClick={() => handlePasswordVisibility()}
                />
              </a>
              <Field
                inputClassName="fin-control"
                type={passwordType}
                name="password"
                component={ValidatedInput}
                placeholder="Password"
              />
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <label className="custom-checkbox mr-1">
              <Field
                type="checkbox"
                component="input"
                name="rememberMe"
                id="rememberMe"
              />
              <span>Remember me</span>
            </label>
            <Link className="text-small text-muted" to={"/forgot-password"}>
              Forgot password
            </Link>
          </div>
          <button
            className="btn btn-main d-block w-100"
            disabled={submitting || pristine}
          >
            Login
          </button>
          <p className="text-small text-center mt-45">
            {"Don't have an account yet?"}{" "}
            <Link className="d-inline-block link-color" to={"/sign-up"}>
              Create account
            </Link>
          </p>
        </form>
      )}
    />
  );
};

LoginForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default LoginForm;
